module.exports = __webpack_public_path__ + "d878b6c29b10beca227e9eef4246111b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/lato/Lato-Bold.woff
// module id = 593
// module chunks = 0